import { FacebookIcon, YoutubeIcon, LinkedinIcon } from '@/components/icons';

const LINKS = [
  { label: 'Facebook', href: 'https://www.facebook.com/CeylonCharts',            Icon: FacebookIcon, hoverColor: '#1877F2' },
  { label: 'YouTube',  href: 'https://www.youtube.com/@SerendibWealth',          Icon: YoutubeIcon,  hoverColor: '#FF0000' },
  { label: 'LinkedIn', href: 'https://www.linkedin.com/company/ceyloncharts/',   Icon: LinkedinIcon, hoverColor: '#0A66C2' },
];

interface Props {
  size?: number;
  className?: string;
}

export function SocialLinks({ size = 16, className = '' }: Props) {
  return (
    <div className={`flex items-center gap-3 ${className}`}>
      {LINKS.map(({ label, href, Icon, hoverColor }) => (
        <a
          key={label}
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={`CeylonCharts on ${label}`}
          title={label}
          className="text-muted transition-colors"
          onMouseEnter={(e) => { e.currentTarget.style.color = hoverColor; }}
          onMouseLeave={(e) => { e.currentTarget.style.color = ''; }}
        >
          <Icon size={size} />
        </a>
      ))}
    </div>
  );
}
